import { CardMedia, Grid } from "@mui/material";

import loadingImg from "../../../assets/loading.gif";
interface ImageContainerPropTypes {
  img?: string;
}
const ImageContainer: React.FC<ImageContainerPropTypes> = ({
  img = loadingImg,
}: ImageContainerPropTypes) => {
  return (
    <Grid container justifyContent="center">
      <Grid item>
        <CardMedia
          sx={
            img === loadingImg
              ? { marginTop: "80%", maxWidth: 275, minWidth: 250 }
              : { maxWidth: "350px" }
          }
          component="img"
          alt="Image container"
          image={img}
          title="Image container"
        />
      </Grid>
    </Grid>
  );
};

export default ImageContainer;
